export const ANIMATION_INIT         = 0
export const ANIMATION_IN_PROGRESS  = 1
export const ANIMATION_COMPLETED    = 2